import React from 'react'
import { Modal } from 'react-bootstrap'
import { LinkWithLocale, ImageComponent } from 'src/views/components'
import { ProductDetails } from '../ProductDetails'
import { trackGTMEvents, i18nTranslate } from 'src/utils'
import { LoyaltyMFEContainer } from 'src/views/components/LoyaltyMFE/LoyaltyMFEContainer'
import { subscriptionContainer } from 'src/models'
import { currentMonthV2 } from 'src/deps'
import './styles.scss'

class DeleteItemModal extends React.Component {
  trackSubscriptionRemoveNoEvent = () => {
    const { itemDetails } = this.props
    trackGTMEvents({
      event: 'subscriptionRemoveNo',
      name: itemDetails?.productName || '',
      id: itemDetails?.subscriptionId || '',
      price: itemDetails?.subTotal || 0,
      type: 'next orders',
      message: subscriptionContainer.skipDeleteLoyaltyMFEMsg,
    })
  }
  trackSubscriptionRemoveEvent = () => {
    const { itemDetails } = this.props
    trackGTMEvents({
      event: 'subscriptionRemove',
      name: itemDetails?.productName || '',
      id: itemDetails?.subscriptionId || '',
      price: itemDetails?.subTotal || 0,
      type: 'next orders',
      message: subscriptionContainer.skipDeleteLoyaltyMFEMsg,
    })
  }
  render() {
    const { itemDetails, selectedMonth } = this.props
    const subscriptionItemTotal =
      itemDetails?.priceObj?.price * itemDetails?.quantity
    const currentMonth = currentMonthV2()
    const showLoyaltyAlert = selectedMonth === currentMonth + 1
    return (
      <Modal {...this.props} className="delete-modal-container" centered>
        <Modal.Header closeButton>
          <Modal.Title
            className="delete-modal-question"
            data-testid="qa-sub-delete-title">
            {i18nTranslate(
              'subscription.itemRemoveQuestion',
              'Do you want to remove this from your subscription?'
            )}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {showLoyaltyAlert && (
            <LoyaltyMFEContainer
              componentName="App"
              isFrom="DELETE"
              itemValue={subscriptionItemTotal}
            />
          )}
          <div className="delete-modal-description d-flex">
            <div className="product-list-product-img">
              <LinkWithLocale
                to={{
                  pathname: itemDetails.url || '',
                }}
                className={`prod-image-wrapper w-100`}>
                <ImageComponent
                  width="100px"
                  height="100px"
                  optimizeImage={true}
                  src={itemDetails.productImage}
                  alt={itemDetails.productName}
                  className={`mw-100 mh-100 prod-img`}
                  data-testid="qa-user-sub-product-image"
                />
              </LinkWithLocale>
            </div>
            <ProductDetails productData={itemDetails} isFromDelete={true} />
          </div>
          <div className="delete-modal-button-container">
            <button
              className="delete-modal-button-back"
              data-testid="qa-sub-delete-keep-me-button"
              onClick={() => {
                this.trackSubscriptionRemoveNoEvent()
                this.props.onHide()
              }}>
              {i18nTranslate(
                'subscription.itemRemoveBackButton',
                'No, keep me subscribed'
              )}
            </button>
            <button
              className="delete-modal-button-continue"
              data-testid="qa-sub-delete-button"
              onClick={() => {
                this.trackSubscriptionRemoveEvent()
                this.props.handleCancelItem(itemDetails.subscriptionId)
              }}>
              {i18nTranslate(
                'subscription.itemRemoveConfirmButton',
                'Yes, remove this item'
              )}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}
export default DeleteItemModal
export { DeleteItemModal }
